import { BackgroundColor } from '@ampcore/ampcom-contracts'

export const heroTopicFrontBackgroundColors = [
  BackgroundColor.MIDNIGHT_BLUE,
  BackgroundColor.LIGHT_BLUE,
  BackgroundColor.PURPLE,
  BackgroundColor.BERRY,
  BackgroundColor.DARK_MINT,
  BackgroundColor.WHITE // HeroWIthImageOnly
] as const

export type HeroTopicFrontBackgroundColor =
  (typeof heroTopicFrontBackgroundColors)[number]
